
import {defineComponent, ref} from 'vue';
import Notifications from './Notifications';
import axios, {AxiosError, AxiosResponse} from "axios";

export default defineComponent({
    name: 'job-alert-button',
    props: {
        url: {
            type: String,
            required: true
        },
        filter: {
            type: Object,
        },
        languageUid: {
            type: Number,
        },
        search: {
            type: String,
        },
        vapidKeys: {
            type: Object,
        }
    },
    setup(props) {
        let timer: number, isGrantedFlashMsgActive = ref(false), isDeniedFlashMsgActive = ref(false);

        const notifications = new Notifications(props.vapidKeys);

        const setPushNotification = () => {
            if ('Notification' in window) {
                Notification.requestPermission().then(async (permission) => {
                    if (permission === 'granted') {
                        await clearTimeout(timer);
                        notifications.init({
                            filter: props.filter,
                            languageUid: props.languageUid,
                            search: props.search
                        });
                        isGrantedFlashMsgActive.value = true;
                        timer = window.setTimeout(() => {
                            isGrantedFlashMsgActive.value = false;
                        }, 5000);
                    } else {
                        await clearTimeout(timer);
                        isDeniedFlashMsgActive.value = true;
                        timer = window.setTimeout(() => {
                            isDeniedFlashMsgActive.value = false;
                        }, 5000);

                    }
                })
            }
        }

        return {
            setPushNotification, isGrantedFlashMsgActive, isDeniedFlashMsgActive
        };
    },
});
